/* tslint:disable */
/* eslint-disable */
/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { SafetyChecklistConditionAvailableRecipientsResponse } from '../models';
import { SafetyChecklistConditionEditCommand } from '../models';
import { SafetyChecklistConditionEditQueryResponse } from '../models';
import { SafetyChecklistConditionSearchResponse } from '../models';
import { SharedModelsCommandIdResponse } from '../models';
/**
 * SafetyChecklistConditionApi - axios parameter creator
 * @export
 */
export const SafetyChecklistConditionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionAvailablerecipientsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklistcondition/availablerecipients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [conditionId] 
         * @param {string} [templateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionEditGet: async (conditionId?: string, templateId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklistcondition/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (conditionId !== undefined) {
                localVarQueryParameter['ConditionId'] = conditionId;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['TemplateId'] = templateId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SafetyChecklistConditionEditCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionEditPost: async (body?: SafetyChecklistConditionEditCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklistcondition/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionSearchGet: async (searchTerm?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklistcondition/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyChecklistConditionApi - functional programming interface
 * @export
 */
export const SafetyChecklistConditionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistconditionAvailablerecipientsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistConditionAvailableRecipientsResponse>> {
            const localVarAxiosArgs = await SafetyChecklistConditionApiAxiosParamCreator(configuration).apiSafetychecklistconditionAvailablerecipientsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [conditionId] 
         * @param {string} [templateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistconditionEditGet(conditionId?: string, templateId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistConditionEditQueryResponse>> {
            const localVarAxiosArgs = await SafetyChecklistConditionApiAxiosParamCreator(configuration).apiSafetychecklistconditionEditGet(conditionId, templateId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SafetyChecklistConditionEditCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistconditionEditPost(body?: SafetyChecklistConditionEditCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandIdResponse>> {
            const localVarAxiosArgs = await SafetyChecklistConditionApiAxiosParamCreator(configuration).apiSafetychecklistconditionEditPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistconditionSearchGet(searchTerm?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistConditionSearchResponse>> {
            const localVarAxiosArgs = await SafetyChecklistConditionApiAxiosParamCreator(configuration).apiSafetychecklistconditionSearchGet(searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SafetyChecklistConditionApi - factory interface
 * @export
 */
export const SafetyChecklistConditionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionAvailablerecipientsGet(options?: any): AxiosPromise<SafetyChecklistConditionAvailableRecipientsResponse> {
            return SafetyChecklistConditionApiFp(configuration).apiSafetychecklistconditionAvailablerecipientsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [conditionId] 
         * @param {string} [templateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionEditGet(conditionId?: string, templateId?: string, options?: any): AxiosPromise<SafetyChecklistConditionEditQueryResponse> {
            return SafetyChecklistConditionApiFp(configuration).apiSafetychecklistconditionEditGet(conditionId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SafetyChecklistConditionEditCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionEditPost(body?: SafetyChecklistConditionEditCommand, options?: any): AxiosPromise<SharedModelsCommandIdResponse> {
            return SafetyChecklistConditionApiFp(configuration).apiSafetychecklistconditionEditPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistconditionSearchGet(searchTerm?: string, options?: any): AxiosPromise<SafetyChecklistConditionSearchResponse> {
            return SafetyChecklistConditionApiFp(configuration).apiSafetychecklistconditionSearchGet(searchTerm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyChecklistConditionApi - object-oriented interface
 * @export
 * @class SafetyChecklistConditionApi
 * @extends {BaseAPI}
 */
export class SafetyChecklistConditionApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistConditionApi
     */
    public apiSafetychecklistconditionAvailablerecipientsGet(options?: any) {
        return SafetyChecklistConditionApiFp(this.configuration).apiSafetychecklistconditionAvailablerecipientsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [conditionId] 
     * @param {string} [templateId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistConditionApi
     */
    public apiSafetychecklistconditionEditGet(conditionId?: string, templateId?: string, options?: any) {
        return SafetyChecklistConditionApiFp(this.configuration).apiSafetychecklistconditionEditGet(conditionId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SafetyChecklistConditionEditCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistConditionApi
     */
    public apiSafetychecklistconditionEditPost(body?: SafetyChecklistConditionEditCommand, options?: any) {
        return SafetyChecklistConditionApiFp(this.configuration).apiSafetychecklistconditionEditPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistConditionApi
     */
    public apiSafetychecklistconditionSearchGet(searchTerm?: string, options?: any) {
        return SafetyChecklistConditionApiFp(this.configuration).apiSafetychecklistconditionSearchGet(searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
}
